var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"practice_page",on:{"contextmenu":_vm.preventNativeLongPress,"selectstart":_vm.preventNativeLongPress}},[_c('topController'),_c('mainController'),_c('editor'),_c('layerPanel'),_c('noviceGuide')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }